<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">

            <el-form-item label="股票代码：">
                <el-input v-model.trim="searchForm.skNum" @keyup.enter.native="getListHandler" placeholder="请输入股票代码"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="查询日期：">
                <el-date-picker v-model="searchForm.dayTime" type="date" placeholder="选择查询日期"
                    value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="查询时分：">
                <el-time-picker v-model="searchForm.minTime" placeholder="选择查询时分" value-format="HH:mm"
                    format="HH:mm"></el-time-picker>
            </el-form-item>

            <el-form-item label="涨幅大于：">
                <el-input v-model.trim="searchForm.chgParent" @keyup.enter.native="getListHandler" placeholder="请输入涨幅"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="跌幅大于：">
                <el-input v-model.trim="searchForm.chgSubParent" @keyup.enter.native="getListHandler" placeholder="请输入跌幅"
                    clearable></el-input>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜索</el-button>
                <el-button type="primary" class="onlyBtn" @click="importSkFlg = true">导入系统数据</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" style="width:100%;margin-top: 20px;" border fit highlight-current-row
            :header-cell-style="{ background: '#f5f5f5' }" :default-sort="{ prop: 'rpTime', order: 'descending' }">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="skNum" label="股票代码"></el-table-column>
            <el-table-column prop="skName" label="股票名称"></el-table-column>
            <el-table-column prop="skTime" label="开盘日期"></el-table-column>
            <el-table-column prop="openPrice" label="开盘价格"></el-table-column>
            <el-table-column prop="endPrice" label="收盘价格"></el-table-column>
            <el-table-column prop="maxPrice" label="盘中最高价"></el-table-column>
            <el-table-column prop="minPrice" label="盘中最低价"></el-table-column>
            <el-table-column prop="orderNum" label="成交量"></el-table-column>
            <el-table-column prop="orderPrce" label="成交额"></el-table-column>
            <el-table-column prop="chgParent" label="涨跌幅/%"></el-table-column>
            <el-table-column prop="chgPrice" label="振幅"></el-table-column>

            <!-- <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button @click="goToInfoFailPage(scope.row.skNum, $event)" type="text"
                        size="small">查询股票详情</el-button>
                </template>
            </el-table-column> -->

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>




        <el-dialog :append-to-body="true" title="导入股票数据" :visible.sync="importSkFlg" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('mould/import/excelMin')" :headers="setHeader()"
                        :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div>
        </el-dialog>




    </div>
</template>
<script>
import common from '@/utils/common.js'
import { getBgdRechargeList, getBgdRechargeFailLists, getPkgListOfGroup } from '@/api/sim.js'
export default {
    data() {
        return {
            batchOptForm: {
                state: '',
            },
            importSkFlg: false,

            currentId_fail: '',
            stockForm: {
                yearTime: '',
                monthTime: '',
                chgNum: '',
                skNum: '',
            },

            textRemark: '无次月停机',
            editVisibale: false,
            editForm: {
                type: "",
                supplierNames: '',
                supplierCodes: [],
            },
            branchSupplierOption: [],



            searchForm: {
                lunState: '',
                name: '',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            failVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    methods: {
        sureBatchChgStateHandler() {
            this.$refs.batchOptForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getListPageHandle();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },



        confirmHandler() {
            var d = {
                ...this.editForm
            }
            d.supplierCodes = d.supplierCodes.join("，");
            let path = "lunxun/manage/state";
            common.sysRequest(path, d, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.cancel();
                    this.getListPageHandle();

                } else {
                    this.$message.error(res.data.message);
                }
            })

        },
        showSimManage(type) {
            if (type == 2) {
                this.textRemark = '有可用套餐复机'
            } else {
                this.textRemark = '无次月停机';
            }
            this.editForm.type = type;
            this.editVisibale = true;
        },

        chooseAll() {
            let val = [];
            for (let i in this.branchSupplierOption) {
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll() {
            this.editForm.supplierCodes = [];
        },



        showEditDialog(id) {
            this.$confirm("因系统会不间断轮询卡，执行失败卡轮询会占用大量服务器资源，失败数据过多可能会影响服务器稳定。 确定还要执行失败卡轮询吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('lunxun/reload/fail/sim', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getListPageHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
            })



        },
        cancel() {
            this.editForm = {
                type: "",
                supplierCodes: [],
            }
            this.editVisibale = false;
            this.failVisible = false;
            this.importSkFlg = false;
        },
        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('mould/stock/list/min', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },
        //失败列表
        goToInfoFailPage(skNum, $event) {
            this.failVisible = true;
            this.currentId_fail = skNum;
            this.stockForm.skNum = skNum;
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', this.stockForm);
            common.sysRequest('mould/stock/list/info', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg_fail');

            })
        },
        handleCurrentChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },
        //执行sim卡轮训
        lunXunSimTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '如果有轮训尚未结束，请勿重复执行轮训！确定要手动执行SIM卡轮训吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.getListPageHandle();
                                this.$message.success(res.data.message);
                                done();
                            } else {
                                this.$message.error(res.data.message);
                                done();
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })


        },
        //执行代理商统计
        lunXunAgentTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行代理商统计吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/agentCount', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunPauseTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行没有次月套餐停机吗？此操作请谨慎操作！')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/pause/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunActiveTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行有有效套餐复机吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/active/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        //重新购买
        buyPkgReload(rowData) {
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo: rowData.downOrder,
                isNextMonth: rowData.isNextMonth,
                packgeId: rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        }


    },

    created() {
        common.getPkgGroupListCom(this, 'branchSupplierOption');
        this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;;
        this.getListPageHandle();
    },
    mounted() {
        this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;
    },
    computed: {
        fluxPollDetailIccid: function () {
            return this.$store.state.menu.fluxPollDetailIccid;;
        },

    },

    watch: {
        fluxPollDetailIccid: function () {
            this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;;
            this.getListPageHandle();
        },
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }

    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

